import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { getDate } from '../../../../utils/DateUtil'
import AppStore from '../../../../store/AppStore'
import { push } from '@lagunovsky/redux-react-router'
import { Grid } from '@mui/material'

class AssigmentPanel extends Component {
    constructor(props) {
        super(props)
    }

    createRow = (value) => {
        if (value) {
            return (
                <Grid container>
                    <Grid size={12} sx={{ padding: 0 }}>
                        <span className='font-size-16'>{ value }</span>
                    </Grid>
                </Grid>
            )
        }
        return null
    }

    render() {
        return (
            <div className='card no-margin'>
                <div className='card-content'>
                    <Grid container className='clickable' onClick={ () => AppStore.dispatch(push(this.props.link)) }>
                        <Grid size={7} sx={{ padding: 0 }}>
                            <Grid container>
                                <Grid size={1} sx={{ padding: 0 }}>
                                    { this.props.statusIcon || null }
                                </Grid>
                                <Grid size={11} sx={{ padding: 0 }}>
                                    <Grid container>
                                        <Grid size={12}>
                                            { this.createRow(this.props.title) }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            { this.createRow(this.props.secondLineFirstValue) }
                            { this.createRow(this.props.thirdLineFirstValue) }
                            { this.createRow(this.props.fourthLineFirstValue) }
                        </Grid>
                        <Grid size={5} sx={{ padding: 0, textAlign: 'right' }}>
                            { this.createRow(`${i18n.installedSince} ${getDate(this.props.installationDate)}`) }
                            { this.createRow(this.props.secondLineSecondValue) }
                            { this.createRow(this.props.thirdLineSecondValue) }
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}

AssigmentPanel.propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
    statusIcon: PropTypes.element,
    installationDate: PropTypes.string,
    secondLineFirstValue: PropTypes.string,
    secondLineSecondValue: PropTypes.string,
    thirdLineFirstValue: PropTypes.string,
    thirdLineSecondValue: PropTypes.string,
    fourthLineFirstValue: PropTypes.string,
}

export default AssigmentPanel
